


























































import Component from 'vue-class-component';
import Vue from 'vue';
import ClassCard from '../character/classCard.vue';
import { ClassCardData } from '@/interfaces/character/classCard';
import { CharacterClasses } from '@/classes/character/classes';
import FirebaseGateway from '../../classes/firebaseGateway';
import { Watch } from 'vue-property-decorator';

@Component({ components: { ClassCard } })
export default class Rules extends Vue {
  private ruleModel: number | undefined = -1;
  private searchModel: string = '';
  private selectClassModel = 'all';
  private createDialog = false;
  private classOfCard: string = '';
  private file: File | null = null;
  private previewUrl: string = '';
  private title = '';
  private description = '';
  private creationRunning = false;
  private classCardsLoading = false;

  get allClassCards(): ClassCardData[] {
    let classCards: ClassCardData[] = this.$store.getters.classCards;
    if (this.selectClassModel !== '' && this.selectClassModel !== 'all') {
      classCards = classCards.filter((card) => card.classValue === this.selectClassModel);
    }
    if (this.searchModel !== '') {
      const needle = this.searchModel.toLowerCase();
      classCards = classCards.filter((card) => {
        return card.title.toLowerCase().includes(needle) || card.description.toLowerCase().includes(needle);
      });
    }
    return classCards.sort((cardA, cardB) => (cardA.title < cardB.title ? -1 : 1));
  }

  get currentWorld(): string | null {
    return this.$store.getters.currentWorld;
  }

  get allClasses() {
    return CharacterClasses.allClasses;
  }

  get allClassesAndAll() {
    return [{ text: 'Alle', value: 'all' }].concat(this.allClasses);
  }

  private getClassNameByValue(classValue) {
    const result = this.allClasses.find((classObject) => classObject.value === classValue);
    if (typeof result === 'undefined') {
      throw new Error('Could not find classname for ' + classValue);
    }
    return result.text;
  }

  private createClassCard() {
    if (this.file === null) {
      throw new Error('File is null');
    }
    this.creationRunning = true;
    const cardData: ClassCardData = {
      id: null,
      className: this.getClassNameByValue(this.classOfCard),
      classValue: this.classOfCard,
      title: this.title,
      description: this.description,
      imageUrl: null,
    };

    new FirebaseGateway()
      .uploadFile(this.file, '/worlds/' + this.currentWorld + '/rules/classcards/', false)
      .then((downloadUrl) => {
        cardData.imageUrl = downloadUrl;
        this.$store.dispatch('uploadClassCard', cardData);
      })
      .finally(() => {
        this.creationRunning = false;
        this.createDialog = false;
        this.title = '';
        this.description = '';
        this.file = null;
        this.classOfCard = '';
      });
  }

  private onFilePicked(file) {
    if (file !== undefined && file !== null) {
      this.previewUrl = '';
      const fr = new FileReader();
      fr.addEventListener('load', () => {
        this.previewUrl = fr.result as string;
        this.file = file;
      });
      fr.readAsDataURL(file);
    } else {
      this.file = null;
      this.previewUrl = '';
    }
  }

  @Watch('ruleModel')
  private loadClassCards(newValue, oldValue) {
    if (newValue === 0) {
      this.classCardsLoading = true;
      this.$store.dispatch('loadClassCards').then(() => {
        this.classCardsLoading = false;
      });
    }
  }
}
